'use strict';

import { CoreRepository } from '../CoreRepository';
import { AgencyReportUpload } from '../../Entities/Agency/AgencyReportUpload';
import { AgencyReportUploadCollection } from '../../Collections/Agency/AgencyReportUploadCollection';

export class AgencyReportUploadRepository extends CoreRepository {
  public getAgencyReportUploads(
    userId: number,
    agencyId: number,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getAgencyReportUploads(userId, agencyId, options).then((response) => {
      const collection = new AgencyReportUploadCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new AgencyReportUpload();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  /* public processAgencyReportUpload(userId:number, agencyId:number, reportId:number, options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.processAgencyReportUpload(userId,agencyId, reportId, options)
        .then( response => {

            let agencyReportUpload = new AgencyReportUpload();
            agencyReportUpload.hydrate(response);

            return agencyReportUpload;
        });
    } */

  public createAgencyReportUpload(userId: number, agencyId: number, payload: any) {
    return this.webAPI
      .createAgencyReportUpload(userId, agencyId, payload)
      .then((response) => {
        const agencyReportUpload = new AgencyReportUpload();
        agencyReportUpload.hydrate(response);

        return agencyReportUpload;
      })
      .catch((error) => {
        // Handle HTTP 500 errors specifically
        if (error.response && error.response.status === 500) {
          console.warn('Server error (500) occurred. Handling gracefully.');
          return Promise.reject(new Error(error.response));
        }

        // Handle other errors
        return Promise.reject(error);
      });
  }

  public updateAgencyReportUpload(
    userId: number,
    agencyId: number,
    reportId: number,
    payload: object = {}
  ) {
    return this.webAPI
      .updateAgencyReportUpload(userId, agencyId, reportId, payload)
      .then((response) => {
        const agencyReportUpload = new AgencyReportUpload();
        agencyReportUpload.hydrate(response);

        return agencyReportUpload;
      });
  }

  public extractAgencyAgentUpload(userId: number, agencyId: number, reportId: number) {
    return this.webAPI.extractAgencyAgentUpload(userId, agencyId, reportId).then((response) => {
      return response;
    });
  }

  /*
    public getAgencyReportUploads(options: object = {}, criteria: object = null){
        if( !options )
        {
        options = {};
        }

        if( criteria )
        {
        options['criteria'] = criteria;
        }

        return this.webAPI.get(options)
        .then( response => {
            let collection = new AgencyReportUploadCollection();

            response.data.forEach(collectionItemData => {
            let collectionItem = new AgencyReportUpload();
                collectionItem.hydrate(collectionItemData);

            collection.addItem(collectionItem);
            });

            collection.setOffset(response.offset);
            collection.setLimit(response.limit);
            collection.setTotal(response.total);

            return collection;
        });

    }
    */

  /*
    public getAgencyReportUpload(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getAgencyReportUpload(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let AgencyReportUpload = new AgencyReportUpload();
            AgencyReportUpload.hydrate(response);

            return AgencyReportUpload;
        });
    }

    public createAgencyReportUpload(payload: object = {}){  
    return this.webAPI.createAgencyReportUpload(payload)
      .then( response => {
        let AgencyReportUpload = new AgencyReportUpload();
        AgencyReportUpload.hydrate(response);

        return AgencyReportUpload;
      });
    }

    public updateAgencyReportUpload(payload: object = {}){  
        return this.webAPI.updateAgencyReportUpload(payload)
        .then( response => {
            let AgencyReportUpload = new AgencyReportUpload();
            AgencyReportUpload.hydrate(response);

            return AgencyReportUpload;
        });
    }

    public removeAgencyReportUpload( ){
        return this.webAPI.removeAgencyReportUpload()
        .then( response => {
            return response;
        });
    }
    */
}
